



































































import IInbound from '@/store/models/IInbound';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import IRolePermission from '@/store/models/IRolePermission';
import Snackbar from '@/components/shared/Snackbar.vue';
import moment from 'moment';
import IInboundDetail from '@/store/models/IInboundDetail';

@Component({
    components: {
        Snackbar
    }
})
export default class CustomerInboundsSelector extends Vue {
    searchInbound: string = "";
    headers: any = [
        { text: 'Company Source', align: 'start', value: 'companySourceName' },
        { text: 'Customer Name', value: 'customerName' },
        { text: 'Dossier Number', value: 'code' },
        { text: 'Dossier Number Destination', value: 'codeDestination' },
        { text: 'Date In', value: 'dateIn' },
        { text: 'Status', value: 'statusName' }
    ];
    headersInboundDetail: any = [
        { text: 'Good',
            align: 'start',
            value: 'goodName'
        },
        { text: 'Pallet', value: 'palletName' },
        { text: 'Pallet amount', value: 'palletsAmount' },
        { text: 'Cases per pallet', value: 'casesPerPallet' },
        { text: 'Total cases', value: 'totalCases' },
        { text: 'Goods per case', value: 'goodsPerCase' },
        { text: 'Total goods', value: 'totalGoods' },
        { text: 'Best before date', value: 'bestBeforeDate' }
    ];

    @Prop({ type: Array, required: true })
    InboundList !: IInbound[];
    @Prop({ type: Array, required: true })
    InboundDetailList !: IInboundDetail[];
    @Prop({ type: Array, required: true })
    Permissions !: IRolePermission[];
    
    selectedInbound: IInbound[] = [];
    dateIn: string = new Date().toISOString().substr(0, 10);

    @Watch('selectedInbound')
    onChangeInbound() {
        this.$emit('inboundChanged', this.selectedInbound[0]);
    }

    ToDateFormat(date: string) : string {
        if (date === "" || date === null) {
            return "";
        }
        return moment(new Date(date)).format('DD-MM-YYYY');
    }

    showMessageInfo(message: string) {
        (this.$refs.snackbar as Snackbar).showInfo(message);
    }

    showMessageError(message: string) {
        (this.$refs.snackbar as Snackbar).showError(message);
    }
    
    showMessageWarning(message: string) {
        (this.$refs.snackbar as Snackbar).showWarning(message);
    }
}
